import React from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../authConfig';

function handleLogin(instance) {
  instance.loginRedirect({ ...loginRequest, redirectUri: `${window.location.origin}/dashboard` }).catch((e) => {
    console.error(e);
  });
}

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export function SignInButton() {
  const { instance } = useMsal();
  const [t] = useTranslation();
  return (
    <button className="ml-auto" onClick={() => handleLogin(instance)}>
      {t('common.header.menu.login')}
    </button>
  );
}
